import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

// Start Admin Login Code Here ----------------------------------------
const login = async (user) => {
  const response = await axios.post(`${base_url}user/admin-login`, user);
  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data));
    localStorage.setItem("role", JSON.stringify(response.data.role));
    localStorage.setItem("email", JSON.stringify(response.data.email));
    localStorage.setItem("token", JSON.stringify(response.data.token));

  }
  return response.data;
};
const getOrders = async () => {
  const response = await axios.get(`${base_url}user/getallorders`, config);

  return response.data;
};
const getOrder = async (id) => {
  const response = await axios.post(
    `${base_url}user/getorderbyuser/${id}`,
    "",
    config
  );

  return response.data;
};

const sendOtp = async (email) => {
  const response = await axios.post(`${base_url}user/send-otp`, { email });
  return response.data;
};

const verifyOtpReset = async (data) => {
  const response = await axios.post(`${base_url}user/verify-otp-reset`, data);
  return response.data;
};

const verifyOtpOnly = async (data) => {
  const response = await axios.post(`${base_url}user/verify-otp-only`, data);
  return response.data;
};

const authService = {
  login,
  getOrders,
  getOrder,
  sendOtp,
  verifyOtpOnly,
  verifyOtpReset,
};

export default authService;
